import { render, staticRenderFns } from "./talk-list.vue?vue&type=template&id=f9a36112&scoped=true"
import script from "./talk-list.vue?vue&type=script&lang=js"
export * from "./talk-list.vue?vue&type=script&lang=js"
import style0 from "./talk-list.vue?vue&type=style&index=0&id=f9a36112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a36112",
  null
  
)

export default component.exports